import 'styles/PhotoFeed.less'
import React, { Component, PropTypes } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import Waypoint from 'react-waypoint'
import classNames from 'classnames/bind'
import Loading from 'components/Utils/Loading'
import photo from '../../../datas/photos/index.json'
import Image from 'components/Gallery/Image'
import ImageViewer from 'components/Gallery/ImageViewer'
import * as actions from 'actions'

const INITIAL_FEED_SIZE = 12
const GRID_COLUMNS = 10
const MIN_FIRST_IMAGE_WIDTH_COLUMNS = 5
const MIN_IMAGE_WIDTH_COLUMNS = 3
const MAX_IMAGE_WIDTH_COLUMNS = 10

class Camp2017PhotoFeed extends Component {
  constructor(props) {
    super(props)

    this.ALBUMS = {
      'bali': 'camp-2017-bali',
      'chiba': 'camp-2017-chiba',
      'danube': 'camp-2017-romania',
      'france': 'camp-2017-france',
      'japan1': 'camp-2018-japan1',
      'japan2': 'camp-2018-japan2',
      'usa1': 'camp-2018-usa1',
      'usa2': 'camp-2018-usa2',
      'japan': 'camp-2019-japan',
    }

    this.initFeed(this.props.campId)
    this.onLoad = this.onLoad.bind(this)
    this._extendList = this._extendList.bind(this)
  }

  initFeed(campId) {
    let regularImages = photo[this.ALBUMS[campId]].image
    for (let i = 1; i < regularImages.length; i++) {
      let j = this.getRandom(0, i - 1)
      const aux = regularImages[i]
      regularImages[i] = regularImages[j]
      regularImages[j] = aux
    }
    
    this.getImageGrid(regularImages)
    let rowsOnScreen = INITIAL_FEED_SIZE

    let stateObj = {
      campId: this.props.campId,
      imageRows: regularImages,
      rowsOnScreen: rowsOnScreen,
      isLoading: false
    }

    if (this.state) this.setState(stateObj)
    else this.state = stateObj
  }

  getRandom(x, y) {
    return (Math.floor((Math.random() - 0.00001) * (y - x + 1)) + x)
  }

  getImageGrid(regularImages) {
    regularImages.map((image, i) => {
      image.display = true
      image.gridInfo = {}
      // Link to next and previous
      if (i == 0) {
        image.next = regularImages[i + 1]
        image.prev = regularImages[regularImages.length - 1]
      } else if (i == regularImages.length - 1) {
        image.next = regularImages[0]
        image.prev = regularImages[i - 1]
      } else {
        image.next = regularImages[i + 1]
        image.prev = regularImages[i - 1]
      }
      // Do positioning--we need to set up a width and a position in the grid for each one.
      // We have a grid of 10.
      if (i == 0) {
        image.gridInfo.width = this.getRandom(MIN_FIRST_IMAGE_WIDTH_COLUMNS, MAX_IMAGE_WIDTH_COLUMNS)
        image.gridInfo.position = this.getRandom(0, 1) ? 0 : GRID_COLUMNS - image.gridInfo.width
        image.gridInfo.connectionType = -1
      } else {
        let prevLeft = regularImages[i - 1].gridInfo.position
        let prevWidth = regularImages[i - 1].gridInfo.width
        let prevRight = prevLeft + prevWidth
        let prevConnectionType = regularImages[i - 1].gridInfo.connectionType
        let connectionType

        let placementResolved = false
        let trials = 0
        connectionType = this.getRandom(0, 3)
        while (!placementResolved) {
          switch (connectionType) {
            case 0: // Connect current image right corner to previous image left corner.
              if (prevLeft >= MIN_IMAGE_WIDTH_COLUMNS) {
                placementResolved = true
                image.gridInfo.width = this.getRandom(MIN_IMAGE_WIDTH_COLUMNS, prevLeft)
                image.gridInfo.position = prevLeft - image.gridInfo.width
                image.gridInfo.connectionType = 0
              }
              break
            case 1: // Connect current image right corner to previous image right corner.
              if (prevRight >= MIN_IMAGE_WIDTH_COLUMNS) {
                placementResolved = true
                image.gridInfo.width = this.getRandom(MIN_IMAGE_WIDTH_COLUMNS, prevRight)
                image.gridInfo.position = prevRight - image.gridInfo.width
                image.gridInfo.connectionType = 1
              }
              break
            case 2: // Connect current image left corner to previous image left corner.
              if (GRID_COLUMNS - prevLeft >= MIN_IMAGE_WIDTH_COLUMNS) {
                placementResolved = true
                image.gridInfo.width = this.getRandom(MIN_IMAGE_WIDTH_COLUMNS, GRID_COLUMNS - prevLeft)
                image.gridInfo.position = prevLeft
                image.gridInfo.connectionType = 2
              }
              break
            case 3: // Connect current image left corner to previous image right corner.
              if (GRID_COLUMNS - prevRight >= MIN_IMAGE_WIDTH_COLUMNS) {
                placementResolved = true
                image.gridInfo.width = this.getRandom(MIN_IMAGE_WIDTH_COLUMNS, GRID_COLUMNS - prevRight)
                image.gridInfo.position = prevRight
                image.gridInfo.connectionType = 3
              }
              break
          }
          // Absolutely NO two consecutive large images.
          if (image.gridInfo.width + prevWidth > 14) placementResolved = false
          // Try getting a size variety from the previous image.
          if (trials < 10 && Math.abs(image.gridInfo.width - prevWidth) < 2)  placementResolved = false
          // Try getting a different connection than the previous image.
          if (trials < 10 && image.gridInfo.connectionType == prevConnectionType)  placementResolved = false
          trials++

          connectionType = (connectionType + 1) % 4
        }
      }
    })
  }

  componentWillReceiveProps(nextProps) {
    //if (nextProps.campId != this.state.campId) {
      this.initFeed(nextProps.campId)
    //}
  }

  onLoad(doc) {
    this.setState({
      docLoaded:true,
      attributes:doc.getAttributes()
    })
  }

  _extendList() {
    let currentRowsOnScreen = this.state.rowsOnScreen
    this.setState({
      rowsOnScreen: Math.min(currentRowsOnScreen + INITIAL_FEED_SIZE, this.state.imageRows.length),
      isLoading: false
    })
  }

  infiniteScroll(e) {
    if (!this.refs.photoFeedContainer)
      return
    let currPosition = window.scrollY
    let containerHeight = this.refs.photoFeedContainer.offsetHeight

    let displayRows = this.state.imageRows.slice(0, this.state.rowsOnScreen)
    for (let i = 0; i < displayRows.length; i++) {
      let img = `image${i}`
      const domNode = ReactDOM.findDOMNode(this.refs[img])
      const posY = domNode.getBoundingClientRect().y
      if (posY + 100 > window.innerHeight)
        domNode.style.opacity = 0
      else
        domNode.style.opacity = 1
    }

    if (currPosition + (window.innerHeight * 1.3) >= containerHeight && !this.state.isLoading && this.state.rowsOnScreen < this.state.imageRows.length) {
      this.setState({
        isLoading: true
      })
      this._extendList()
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', this.infiniteScroll.bind(this), false)
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.infiniteScroll, false)
  }
  handleImageClick(photo) {
    this.props.dispatch(actions.token.toggleModal({
      modalIsOpen: true,
      modalContent: photo
    }))
  }
  render() {
    let displayRows = this.state.imageRows.slice(0, this.state.rowsOnScreen)
    let loadingClass = classNames({'no-display': !this.state.isLoading})
    //console.log(displayRows)
    return (
      <div className="camp-2017-photo-feed" ref="photoFeedContainer">
        { displayRows.map((photo, i) => {
          let style = {
            position: 'relative',
            width: `${photo.gridInfo.width * 100.0 / GRID_COLUMNS}vw`,
            height: 'auto',
            left: `${photo.gridInfo.position * 100.0 / GRID_COLUMNS}vw`
          }
          let refHandle = `image${i}`
          return (<div className='opacity-fade-in' ref={refHandle}><Image style={style} onClick={this.handleImageClick.bind(this, photo)} photo={photo} key={photo.id + ' ' + i} highRes={true} typeOfLoading={Image.loadType.GREY} myId={photo.id}/></div>)
        })}
        <Loading className={loadingClass}/>
      </div>

    )
  }
}

Camp2017PhotoFeed.contextTypes = {
}
Camp2017PhotoFeed.propTypes = {
}
function mapStateToProps(state, ownProps) {
  return {
    location: ownProps.location,
    alertIsClosed: state.token.alertIsClosed,
    footerIsHidden: state.token.footerIsHidden
  }
}

export default connect(mapStateToProps)(Camp2017PhotoFeed)



// WEBPACK FOOTER //
// ./src/components/Gallery/Camp2017PhotoFeed.js